

import { useState, useEffect } from "react"
import styles from "./BetSlip.module.css"

export default function BetSlip({ bet, onClose, isMobile = false, onBetSubmit }) {

  console.log("bet===>>>", bet)
  const [stake, setStake] = useState("")
  const [profit, setProfit] = useState("0 / -0")

  // Add useEffect to recalculate profit when bet changes
  useEffect(() => {
    if (stake && bet) {
      calculateProfit(stake)
    }
  }, [bet, stake])

  if (!bet) return null

  const quickAmounts = ["10,000", "250,000", "50,000", "100,000", "+100,000", "+250,000", "+500,000", "+1,000,000"]

  const handleQuickAmount = (amount) => {
    const cleanAmount = amount.replace(/[+,]/g, "")
    setStake(cleanAmount)
    calculateProfit(cleanAmount)
  }

  const calculateProfit = (stakeValue) => {
    console.log("=== CALCULATE PROFIT DEBUG ===")
    console.log("stakeValue:", stakeValue)
    console.log("bet object:", bet)
    console.log("bet.odds:", bet.odds, "type:", typeof bet.odds)
    console.log("bet.type:", bet.type)
    console.log("bet.bet_type:", bet.bet_type)
    
    if (!stakeValue || stakeValue === "" || stakeValue === "0") {
      console.log("No stake value, setting profit to 0")
      setProfit("0 / -0")
      return
    }

    if (!bet.odds) {
      console.log("No odds found, setting profit to 0")
      setProfit("0 / -0")
      return
    }

    const stakeNum = Number.parseFloat(stakeValue)
    const oddsNum = Number.parseFloat(bet.odds)
    
    console.log("Parsed stake:", stakeNum, "parsed odds:", oddsNum)
    
    if (isNaN(stakeNum) || isNaN(oddsNum)) {
      console.log("Invalid numbers, setting profit to 0")
      setProfit("0 / -0")
      return
    }
    
    // Check both bet.type and bet.bet_type for compatibility
    const betType = (bet.type || bet.bet_type)?.toLowerCase()
    
    console.log("Final bet type:", betType)

    if (betType === "back") {
      const profitAmount = (stakeNum * (oddsNum - 1)).toFixed(0)
      const newProfit = `${profitAmount} / -${stakeNum}`
      console.log("Back bet profit calculated:", newProfit)
      setProfit(newProfit)
    } else if (betType === "lay") {
      const liability = (stakeNum * (oddsNum - 1)).toFixed(0)
      const newProfit = `${stakeNum.toFixed(0)} / -${liability}`
      console.log("Lay bet profit calculated:", newProfit)
      setProfit(newProfit)
    } else {
      console.log("Unknown bet type:", betType, "setting profit to 0")
      setProfit("0 / -0")
    }
    
    console.log("Final profit state should be:", profit)
    console.log("=== END DEBUG ===")
  }

  const handleStakeChange = (e) => {
    let value = e.target.value.replace(/[^\d.]/g, "") // only numbers
    console.log("Stake changed to:", value)
    setStake(value)
    calculateProfit(value)
  }



  const executeBetPlacement = async () => {
    const updatedBet = {
      ...bet,
      stake_amount: stake,
      original_amount: stake,
    };

    try {
      if (onBetSubmit) {
        await onBetSubmit(updatedBet);
      }
      console.log("Submitting bet with final payload:", updatedBet);
      onClose();
    } catch (error) {
      console.error("Error submitting bet:", error);
      alert("Failed to place bet. Please try again.");
    }
  };

  const handleSubmit = async () => {
    if (!stake || stake <= 0) {
      alert("Please enter a valid stake amount");
      return;
    }
    // Submit immediately
    executeBetPlacement();
  };

  const handleClear = () => {
    setStake("")
    setProfit("0 / -0")
  }

  if (isMobile) {
    return (
      <div className={styles.mobileOverlay}>
        <div className={styles.mobileModal}>
          <div className={`${styles.betSlipContent} ${(bet.bet_type || bet.type) === "back" ? styles.backBet : styles.layBet}`}>
            <div className={styles.header}>
              <h3>{bet.teamName}</h3>
              <button className={styles.closeButton} onClick={onClose}>
                ×
              </button>
            </div>

            <div className={styles.oddsSection}>
              <label>ODDS</label>
              <div className={styles.oddsInput}>
                <button>-</button>
                <span>{bet.odds}</span>
                <button>+</button>
              </div>
            </div>

            <div className={styles.amountSection}>
              <label>Amount</label>
              <input
                type="text"
                value={stake}
                onChange={handleStakeChange}
                placeholder="Enter amount"
                className={styles.stakeInput}
              />
            </div>

            <div className={styles.quickAmounts}>
              {quickAmounts.map((amount, index) => (
                <button key={index} className={styles.quickAmountBtn} onClick={() => handleQuickAmount(amount)}>
                  {amount}
                </button>
              ))}
            </div>

            <div className={styles.actions}>
              <button className={styles.closeBtn} onClick={onClose}>
                Close
              </button>
              <button className={styles.submitBtn} onClick={handleSubmit}>
                Submit
              </button>
              <div className={styles.profitDisplay}>
                <strong>Profit/Loss: {profit}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.betSlip} ${(bet.bet_type || bet.type) === "back" ? styles.backBet : styles.layBet}`}>
      <div className={styles.betSlipHeader}>
        <span>Bet Slip</span>
        <span>Edit Bet Sizes</span>
      </div>

      <div className={styles.betSlipTable}>
        <div className={styles.tableHeader}>
          <span>Bet for</span>
          <span>Odds</span>
          <span>Stake</span>
          <span>Profit</span>
        </div>

        <div className={styles.tableRow}>
          <span>{bet.teamName}</span>
          <div className={styles.oddsControl}>
            <span style={{background:'white', padding:'6px'}}>{bet.odds}</span>
            <div className={styles.oddsButtons}>
              <button>▲</button>
              <button>▼</button>
            </div>
          </div>
          <input 
            type="text" 
            value={stake} 
            onChange={handleStakeChange} 
            className={styles.stakeInput}
            placeholder="Enter stake"
          />
          <span className={styles.profitCell}>{profit}</span>
        </div>
      </div>

      <div className={styles.quickAmounts}>
        {quickAmounts.map((amount, index) => (
          <button key={index} className={styles.quickAmountBtn} onClick={() => handleQuickAmount(amount)}>
            {amount}
          </button>
        ))}
      </div>

      <div className={styles.actions}>
        <button className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
        <button className={styles.clearBtn} onClick={handleClear}>
          Clear
        </button>
        <button className={styles.submitBtn} onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  )
}


